import React from 'react'
import PropTypes from 'prop-types'
import styles from './_createDiscoverRouteSection.css'
import Svg from 'components/util/Svg'
import { Heading } from 'components/util'
import { FormattedMessage } from 'react-intl'

function CreateDiscoverRouteSection (props) {
  const inlineStyles = {
    color: '#3d3f45',
    align: 'center',
    desktopFontSize: '34px',
    tabletFontSize: '34px',
    letterSpacing: '2.2px',
    barWidth: '64px',
  }
  const { messages, icons, href, logEvent } = props
  const routeIconsList = icons.map((icon, i) => (
    <RouteIcon key={`${icon.name}-${i}`} name={icon.name} message={icon.message.definition} />
  ))

  return (
    <div className={styles.routeCard}>
      <Heading {...inlineStyles} bottomBar={true}
        headingClassName={styles.routeHeading}>
        <FormattedMessage {...messages.heading} />
      </Heading>
      <div className={styles.routeIcons}>
        {routeIconsList}
      </div>
      <div className={styles.routeButton}>
        <a href={href} onClick={() => logEvent(messages.button.defaultMessage, href)}>
          <FormattedMessage {...messages.button} />
        </a>
      </div>
    </div>
  )
}

function RouteIcon (props) {
  const { name, message } = props
  return (
    <div className={styles.routeIcon}>
      <div className={styles.routeCircle}><Svg name={name} className={styles.circleSvg} /></div>
      <div className={styles.routeIconText}>
        <FormattedMessage {...message} />
      </div>
    </div>
  )
}

RouteIcon.propTypes = {
  name: PropTypes.string,
  message: PropTypes.object,
}

CreateDiscoverRouteSection.propTypes = {
  messages: PropTypes.object,
  icons: PropTypes.array,
  href: PropTypes.string,
  logEvent: PropTypes.func,
}

export default CreateDiscoverRouteSection
